import { z } from "zod";
import { EAccrualPolicyType } from "../types";

export const accrualPolicyEmployeeSchema = z.object({
  companyID: z.string(),
  policyID: z.string(),
  employeeID: z.string(),
  worker: z
    .object({
      first_name: z.string(),
      middle_name: z.string(),
      last_name: z.string(),
      start_date: z.string(),
    })
    .optional(),
  policy: z
    .object({
      name: z.string(),
      type: z.nativeEnum(EAccrualPolicyType),
    })
    .optional(),
  isAssigned: z.boolean(),
  balance: z.number(),
  accrued: z.number(),
  accrualWaitingPeriodBalance: z.number(),
  periodStart: z.string(),
  accrualHistory: z.array(
    z.object({
      periodStart: z.string(),
      accrued: z.number(),
      rolloverToNextPeriod: z.number(),
    })
  ),
  assignmentHistory: z.array(
    z.object({
      isAssigned: z.boolean(),
      updatedAt: z.date(),
    })
  ),
  rolloverDate: z.string().nullable(),
  createdAt: z.date().nullable(),
  updatedAt: z.date().nullable(),
});
